enum Stages {
  GATHERING_INFORMATION = "Gathering Information",
  LOCATING_FACILITY = "Locating Facility",
  CREATING_APPOINTMENT = "Creating Appointment",
  FINAL_FOLLOWUP = "Final Followup"
}

export default Stages;
